<div class="bar">
    <div class="fill" style="width: 80%;"></div>
</div>